module.exports = __webpack_public_path__ + "media/images/pages/icn_balloon_number_red_08-aec8d714303f01351e59d7c29d86acf2.svg";